import {RefObject, useEffect} from 'react';

const useScrollBlock = (isBlocking: boolean, scrollRef?: RefObject<HTMLElement>) => {
  useEffect(() => {
    const scrollTarget = scrollRef?.current ?? document.body;

    if (isBlocking) {
      scrollTarget.style.overflow = 'hidden';
    }
    return () => {
      scrollTarget.style.overflow = '';
    };
  }, [isBlocking]);
};

export default useScrollBlock;
